module.exports = __webpack_public_path__ + "media/images/icons/dollar-43752812ec9d36e8fbdd5d8506b1f0bb.svg";